import { SecureStorage } from "@aparajita/capacitor-secure-storage";
import type { TokenStore } from "@ronin/api-client";

/**
 * spec08 FR7: the session token lives only in Android's Keystore-backed storage (encrypted
 * with a Keystore key), never in localStorage or files. Only the app calls it.
 *
 * Imported statically on purpose: a Capacitor plugin is a Proxy that also answers `then`,
 * so a promise that resolves to the plugin (e.g. a dynamic import's `.then`) never settles.
 */
const KEY = "session";

let cached: string | null | undefined;

export const nativeTokens: TokenStore = {
  async get() {
    if (cached === undefined) cached = await SecureStorage.getItem(KEY);
    return cached;
  },
  async set(token) {
    cached = token;
    if (token) await SecureStorage.setItem(KEY, token);
    else await SecureStorage.removeItem(KEY);
  },
};
